
    var riot = require('riot')
    //src: starling/src/tags/comments/comments-layer.html
riot.tag2('comments-layer',
  '<new-comment-panel canvas="{this.opts.canvas}"></new-comment-panel> <canvas-comment if="{showComments(this)}" each="{canvas.store.topMapComments()}" instance="{this}" canvas="{parent.canvas}"></canvas-comment>',
  '',
  'class="top-level-comments"', function(opts) {
'use strict';

var _commentsUi = require('lib/comments-ui');

var _opts = opts,
    canvas = _opts.canvas;

canvas.commentsLayerTag = this;

Object.assign(this, { canvas: canvas });

this.on('mount', function () {
  _commentsUi.commentsUI.setupDragging();
});

this.showComments = function (comment) {
  if (!canvas.isFeatureEnabled('comments')) return false;
  if (_commentsUi.commentsUI.isShownComment(comment.id)) return true;
  return _commentsUi.commentsUI.showComments();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('comments-layer')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/comments-layer.html
// module id = 788
// module chunks = 0